import { isNil } from 'lodash'
import { OnboardingGateway } from '../models/onboardingModels'
import { resolveApiUrl } from '../utils/requestsUtils'
import { RequestResponse, requestService } from './requestServices'
import { QueryStringInput } from '@hello-aria/query-string'

export type ListOnboardings = {
    companyId: string | undefined
    query?: QueryStringInput
}

export const listOnboardingsServices = async (
    params: ListOnboardings
): Promise<RequestResponse<OnboardingGateway[]> | undefined> => {
    const { query, companyId } = params

    if (isNil(companyId)) return

    const url = resolveApiUrl('onboardings.list', {
        query,
        variables: { companyId }
    })

    return await requestService<OnboardingGateway[]>(url)
}

export const getOnboardingService = async (
    companyId: string,
    onboardingId: string | undefined
): Promise<RequestResponse<OnboardingGateway> | undefined> => {
    if (isNil(onboardingId)) return

    const url = resolveApiUrl('onboardings.get', {
        variables: { companyId, onboardingId }
    })

    return requestService<OnboardingGateway>(url)
}
